// extracted by mini-css-extract-plugin
export default {"container":"MobileTabsSelector_container__dw7yE","tab":"MobileTabsSelector_tab__tZ+n7","tab_active":"MobileTabsSelector_tab_active__Ds418"};